// SPDX-License-Identifier: AGPL-3.0-or-later
import {PREMIUM_PRODUCT_NAME, PRODUCT_NAME, SPLASH_IRC_SERVER} from '@app/features/app/config/I18nDisplayConstants';
import {useLingui} from '@lingui/react/macro';
import {useMemo} from 'react';
export interface SplashQuote {
	readonly text: string;
	readonly source: string;
}
export function useSplashQuotes(): ReadonlyArray<SplashQuote> {
	const {t} = useLingui();
	return useMemo(() => {
		const quotes: Array<SplashQuote> = [
			{text: t`Aren't you supposed to be sleeping?`, source: 'kitkatz'},
			{text: t`After careful consideration, we have decided we did, in fact, need loading lines.`, source: 'vky'},
			{text: t`There is no cloud... only other people's computers.`, source: 'Siliconic'},
			{
				text: t`Did you know that ${PRODUCT_NAME} spelled backwards makes no sense? Why would you do that?`,
				source: 'jackzie',
			},
			{text: t`Have you considered touching grass while you wait?`, source: 'Lilith'},
			{
				text: t`Unfortunately, it doesn't run on regular unleaded gasoline. It requires something with a little more kick. ${PREMIUM_PRODUCT_NAME}.`,
				source: 'Cookie',
			},
			{text: t`9/10 dentists recommend ${PRODUCT_NAME}.`, source: 'Hugopuntocom'},
			{text: t`Is this thing on?`, source: 'Pufty'},
			{text: t`Now supports sending messages over the Internet!`, source: '99'},
			{text: t`Flux capacitors use 99.99% less water than your typical AI data centre!`, source: 'snappyapple632'},
			{text: t`No soldering skills required!`, source: '99'},
			{text: t`Removed Herobrine.`, source: 'Manfre'},
			{text: t`Please enjoy this loading quote while you wait.`, source: 'illspirit'},
			{
				text: t`${PRODUCT_NAME} is 100% powered by flux capacitors. And furries. We don't forget about the furries.`,
				source: 'jb',
			},
			{text: t`Unable to decrypt loading quote.`, source: 'SteveLinkNoah'},
			{text: t`Remember to hydrate! Or don't, I'm not the boss of you.`, source: 'jb'},
			{text: t`Congratulations! This is the special rare loading screen message!`, source: 'jb'},
			{text: 'Nu \u00e4r det dags f\u00f6r en fika.', source: 'Chip'},
			{text: t`Is ${PRODUCT_NAME} loading? Why are you asking me? I'm just a loading screen!`, source: 'Caus'},
			{text: t`Welcome back to 2015!`, source: 'Pan'},
			{text: t`Connecting to ${SPLASH_IRC_SERVER}...`, source: 'viriona'},
			{text: t`Wait, hold on, I'm not ready yet!`, source: 'Vee'},
			{text: t`Feel that? That's ${PRODUCT_NAME}.`, source: 'TheFastestBoy'},
			{text: t`The real fluxer was the friends we made along the way.`, source: 'viriona'},
			{
				text: t`Is ${PRODUCT_NAME} an instrument? No, ${PRODUCT_NAME} is a communication platform.`,
				source: 'Comfy_Deer',
			},
			{text: t`Hi! I'm a loading screen!`, source: 'jackzie'},
			{text: t`3 Billion Devices Run ${PRODUCT_NAME}.`, source: 'jackzie'},
			{text: t`To connect or not to connect, that is the question.`, source: 'Tea'},
			{text: t`Please do not the fluxer.`, source: 'Chris'},
			{text: t`I am the one who fluxes.`, source: 'Anonymous'},
			{text: t`Installing ${PRODUCT_NAME} on the nearest smart fridge...`, source: 'TyphonBagrid'},
			{text: t`Ya like Jazz?`, source: 'catnaros'},
			{text: t`If it smells like chicken, you're holding the soldering iron wrong.`, source: 'viriona'},
			{text: t`Everything is in flux.`, source: 'Alyx'},
			{text: t`Happy new year 1999!`, source: '99'},
			{text: t`Heating up the engine.`, source: 'Ray'},
			{text: t`Pong!`, source: 'Cookie'},
			{text: t`Everyday I'm fluxin' it.`, source: 'Liminalis'},
			{text: 'I am the word', source: 'Bird'},
		];
		quotes.push({
			text: t`Your odds of landing on this particular loading quote were 1 in ${String(quotes.length + 1)}.`,
			source: 'vky',
		});
		return quotes;
	}, [t]);
}
